import { OK } from "config/general/Configuracion";
import {
  CUENTA_GRABAR,
  CUENTA_GRABAR_SUCCESS,
  CUENTA_GRABAR_ERROR,
  CUENTA_LISTAR,
  CUENTA_LISTAR_SUCCESS,
  CUENTA_LISTAR_ERROR,
  CUENTA_PARA_EDITAR,
  CUENTA_USUARIO_LISTAR,
  CUENTA_USUARIO_LISTAR_SUCCESS,
  CUENTA_USUARIO_LISTAR_ERROR,
  CUENTAS_DESDE_ACCESO,
  LISTAR_MAX_PLACA_EXENTA,
  LISTAR_MAX_PLACA_EXENTA_SUCCESS,
  LISTAR_MAX_PLACA_EXENTA_ERROR,
} from "conten/cuentas/CuentaActions";
import { CUENTA_LISTAR_ENRIQUECIDA, GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR, GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR_ERROR, GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR_SUCCESS, GRABAR_LIMITE_MAX_PERFILES_AUXILIAR, GRABAR_LIMITE_MAX_PERFILES_AUXILIAR_ERROR, GRABAR_LIMITE_MAX_PERFILES_AUXILIAR_SUCCESS, GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO, GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO_ERROR, GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO_SUCCESS, GRABAR_LIMITE_MAX_PERFILES_PROMOTOR, GRABAR_LIMITE_MAX_PERFILES_PROMOTOR_ERROR, GRABAR_LIMITE_MAX_PERFILES_PROMOTOR_SUCCESS, GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR, GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR_ERROR, GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR_SUCCESS, GRABAR_LIMITE_MAX_PERFILES_VISOR, GRABAR_LIMITE_MAX_PERFILES_VISOR_ERROR, GRABAR_LIMITE_MAX_PERFILES_VISOR_SUCCESS, GRABAR_LIMITE_MAX_ZONAS, GRABAR_LIMITE_MAX_ZONAS_ERROR, GRABAR_LIMITE_MAX_ZONAS_SUCCESS, GRABAR_LIMITE_PLACA_EXENTA, GRABAR_LIMITE_PLACA_EXENTA_ERROR, GRABAR_LIMITE_PLACA_EXENTA_SUCCESS, LISTAR_MAX_PERFILES_ADMINISTRADOR, LISTAR_MAX_PERFILES_ADMINISTRADOR_ERROR, LISTAR_MAX_PERFILES_ADMINISTRADOR_SUCCESS, LISTAR_MAX_PERFILES_AUXILIAR, LISTAR_MAX_PERFILES_AUXILIAR_ERROR, LISTAR_MAX_PERFILES_AUXILIAR_SUCCESS, LISTAR_MAX_PERFILES_PROMOTOR, LISTAR_MAX_PERFILES_PROMOTOR_ERROR, LISTAR_MAX_PERFILES_PROMOTOR_SUCCESS, LISTAR_MAX_PERFILES_SUPERVISOR, LISTAR_MAX_PERFILES_SUPERVISOR_ERROR, LISTAR_MAX_PERFILES_SUPERVISOR_SUCCESS, LISTAR_MAX_ZONAS, LISTAR_MAX_ZONAS_ERROR, LISTAR_MAX_ZONAS_SUCCESS } from "./CuentaActions";

const initialState = {
  isActivityIndicatorShown: false,
  cuentasDesdeAcceso: [],
  cuentasUsuario: [],
  cuenta: undefined,
  cuentaEditar: undefined,
  cuentas: [],
  paginacion: {
    limite: 5,
    actual: 1,
    filtro: undefined,
    orden: "nombre",
    sentido: "ASC",
  },
};

const cuentaReducer = (state = initialState, action) => {

  switch (action.type) {
    case CUENTA_GRABAR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case CUENTA_GRABAR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuenta: action.data,
      };
    case CUENTA_GRABAR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };
    case CUENTA_LISTAR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case CUENTA_LISTAR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuentas: action.respuestaServidor.cuentas,
        paginacion: action.respuestaServidor.paginacion,
      };
    case CUENTA_LISTAR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };
    case CUENTA_PARA_EDITAR:
      return {
        ...state,
        cuentaEditar: action.cuenta,
      };
    case CUENTA_USUARIO_LISTAR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case CUENTA_USUARIO_LISTAR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuentasUsuario: action.respuestaServidor.cuentas,
      };
    case CUENTA_USUARIO_LISTAR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };
    case CUENTAS_DESDE_ACCESO:
      return {
        ...state,
        cuentasDesdeAcceso: action.cuentasDesdeAcceso,
      };
    case LISTAR_MAX_PLACA_EXENTA:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case LISTAR_MAX_PLACA_EXENTA_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        placaExenta: action.respuestaServidor.placaExenta,
      };
    case LISTAR_MAX_PLACA_EXENTA_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case LISTAR_MAX_ZONAS:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case LISTAR_MAX_ZONAS_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        placaExenta: action.respuestaServidor.placaExenta,
      };
    case LISTAR_MAX_ZONAS_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case LISTAR_MAX_PERFILES_ADMINISTRADOR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case LISTAR_MAX_PERFILES_ADMINISTRADOR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuentas: action.respuestaServidor.cuentas,

      };
    case LISTAR_MAX_PERFILES_ADMINISTRADOR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case LISTAR_MAX_PERFILES_SUPERVISOR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case LISTAR_MAX_PERFILES_SUPERVISOR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuentas: action.respuestaServidor.cuentas,

      };
    case LISTAR_MAX_PERFILES_SUPERVISOR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case LISTAR_MAX_PERFILES_AUXILIAR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case LISTAR_MAX_PERFILES_AUXILIAR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuentas: action.respuestaServidor.cuentas,

      };
    case LISTAR_MAX_PERFILES_AUXILIAR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case LISTAR_MAX_PERFILES_PROMOTOR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case LISTAR_MAX_PERFILES_PROMOTOR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuentas: action.respuestaServidor.cuentas,

      };
    case LISTAR_MAX_PERFILES_PROMOTOR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case CUENTA_LISTAR_ENRIQUECIDA:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuentas: action.respuestaServidor.cuentas,
        paginacion: action.respuestaServidor.paginacion,
      };

    case GRABAR_LIMITE_PLACA_EXENTA:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case GRABAR_LIMITE_PLACA_EXENTA_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuenta: action.data,
      };
    case GRABAR_LIMITE_PLACA_EXENTA_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case GRABAR_LIMITE_MAX_ZONAS:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case GRABAR_LIMITE_MAX_ZONAS_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuenta: action.data,
      };
    case GRABAR_LIMITE_MAX_ZONAS_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };
    case GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuenta: action.data,
      };
    case GRABAR_LIMITE_MAX_PERFILES_ADMINISTRADOR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuenta: action.data,
      };
    case GRABAR_LIMITE_MAX_PERFILES_SUPERVISOR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case GRABAR_LIMITE_MAX_PERFILES_AUXILIAR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case GRABAR_LIMITE_MAX_PERFILES_AUXILIAR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuenta: action.data,
      };
    case GRABAR_LIMITE_MAX_PERFILES_AUXILIAR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuenta: action.data,
      };
    case GRABAR_LIMITE_MAX_PERFILES_MUNICIPIO_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case GRABAR_LIMITE_MAX_PERFILES_VISOR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case GRABAR_LIMITE_MAX_PERFILES_VISOR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuenta: action.data,
      };
    case GRABAR_LIMITE_MAX_PERFILES_VISOR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };

    case GRABAR_LIMITE_MAX_PERFILES_PROMOTOR:
      return {
        ...state,
        isActivityIndicatorShown: true,
      };
    case GRABAR_LIMITE_MAX_PERFILES_PROMOTOR_SUCCESS:
      return {
        ...state,
        isActivityIndicatorShown: false,
        cuenta: action.data,
      };
    case GRABAR_LIMITE_MAX_PERFILES_PROMOTOR_ERROR:
      return {
        ...state,
        isActivityIndicatorShown: false,
      };


    default:
      return state;
  }


};

export default cuentaReducer;
